import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutDriverOrderInformation extends Layout {
    sourceDriverOrderInformation: DataSource;
    tableOrderInformation: Table;
}
